// src/data/prefectures.ts
// Values live in Firestore (gameConfig/prefectures); this module only reads them.
import { getDomain } from '../config/gameConfig';

export interface Prefecture {
    id: string;
    name: string;
    departments: string[];
}

export const getPrefectures = (): Prefecture[] => getDomain<Prefecture>('prefectures');

export const getDepartmentsByPrefecture = (prefectureName: string): string[] => {
    const prefecture = getPrefectures().find(p => p.name === prefectureName);
    return prefecture?.departments || [];
};
